export const NAME = 'reject-form';
